import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ExternalLink from 'yoda-core-components/lib/assets/svg/ExternalLink.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button';
import Image from 'yoda-core-components/lib/components/Image/next/image';
import PointCross from 'yoda-core-components/lib/components/PointCross/PointCross';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sliderActions from 'yoda-site-components/lib/actions/FindStoresAction';
import * as analyticsActions from 'yoda-site-components/lib/actions/AnalyticsAction';
import {
    FIND_STORES_PAGE_SIZE,
    LOCATION_SERVICE_COOKIES_USER_PREFERRED_STORE,
} from 'yoda-site-components/lib/common/Constants';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { SessionStorage } from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

/* eslint-disable react/prefer-stateless-function */
class AppointmentCard extends Component {
    static propTypes = {
        details: PropTypes.oneOfType([PropTypes.object]).isRequired,
        messagesTexts: PropTypes.oneOfType([PropTypes.object]),
        openInNewTab: PropTypes.bool,
        onCardClick: PropTypes.func.isRequired,
        sliderActions: PropTypes.objectOf(PropTypes.func).isRequired,
        analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
        locationServiceStoreInfo: PropTypes.object,
        findStoresDetails: PropTypes.object,
        preferences: PropTypes.object,
    };

    static defaultProps = {
        messagesTexts: {},
        openInNewTab: true,
        locationServiceStoreInfo: {},
        findStoresDetails: {},
        preferences: {},
    };

    getPreferredStore() {
        let returnValue = '';
        const userPreferredStoreCookie = Cookies.load(
            LOCATION_SERVICE_COOKIES_USER_PREFERRED_STORE,
            true
        );
        returnValue = !isEmpty(userPreferredStoreCookie) ? this.props.locationServiceStoreInfo : {};
        return returnValue;
    }

    triggerStoreSelectionSlider = (e) => {
        e?.stopPropagation && e.stopPropagation();

        const { findStores, openSlidePanel, setFindStoreSliderProps } = this.props.sliderActions;
        const {
            triggerBopisDefaultStoreChange,
            triggerBopisPickupStoreChange,
        } = this.props.analyticsActions;

        const { inputZipCode = '' } = this.getPreferredStore();
        /* istanbul ignore next */
        const onSliderSelectStore = () => {
            const keyValue = SessionStorage.getData('setBopisDefaultStore', true);
            if (isEmpty(keyValue)) {
                triggerBopisDefaultStoreChange();
                SessionStorage.setData('setBopisDefaultStore', true, true);
            } else triggerBopisPickupStoreChange();
        };
        const { zipCode = '' } = this.props.findStoresDetails;
        const searchZip = inputZipCode || zipCode;
        /* istanbul ignore else */
        if (searchZip) {
            const { defaultRadius = 25 } = this.props.preferences;
            const payload = {
                zipCode: searchZip,
                miles: defaultRadius,
                pageSize: FIND_STORES_PAGE_SIZE, // number of stores to request per request
                showAvailable: false,
            };
            findStores(payload);
        }
        setFindStoreSliderProps({
            findStoresAction: findStores,
            enableSlimFindStores: true,
            enableProductCardImage: true,
            hideContentScroll: true,
            isMounted: openSlidePanel,
            selectStoreAction: onSliderSelectStore,
            skuSelected: '',
        });
        openSlidePanel();
    };

    render() {
        const { details, messagesTexts, openInNewTab, onCardClick } = this.props;

        if (isEmpty(details)) return null;

        const getAppointmentLink = (e) => {
            e.preventDefault();
            onCardClick && onCardClick(details.name);
        };
        /* eslint-disable no-script-url */
        const imageProps = {
            alt: details.title,
            isLazy: true,
        };
        const imagesForBreakpoints = [
            { src: details.imageUrl[0], filter: dt(['lg:hidden']) },
            { src: details.imageUrl[1], filter: dt(['smMd:hidden']) },
        ];
        const anchorProps = {
            ...(!details.href && { onClick: getAppointmentLink }),
            ...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' }),
            href: details.href || 'javascript:void(0)',
        };
        const textSize = dt(['text-normal', 'lg:text-small']);
        const currentStore = this.getPreferredStore()?.storeName || '';

        return (
            <div
                className={dt([
                    'flex',
                    'flex-col',
                    'lg:flex-row',
                    'bg-white',
                    'w-full',
                    'mb-10',
                    'lg:mb-8',
                ])}
            >
                <div className={`card-image ${dt(['w-full', 'lg:w-1/2'])}`}>
                    {imagesForBreakpoints.map(({ src, filter }, index) => (
                        <a
                            /* eslint-disable react/jsx-props-no-spreading */
                            {...anchorProps}
                            className={`a${index} ${filter}`}
                            key={src}
                        >
                            <PointCross>
                                <Image
                                    /* eslint-disable react/jsx-props-no-spreading */
                                    {...imageProps}
                                    className={dt(['rounded-lg', 'overflow-hidden'])}
                                    src={src}
                                />
                            </PointCross>
                        </a>
                    ))}
                </div>
                <div
                    className={`card-content ${dt([
                        'flex',
                        'flex-col',
                        'lg:w-1/2',
                        'mt-6',
                        'lg:mt-0',
                        'lg:ml-6',
                    ])}`}
                >
                    <p className={`${textSize} ${dt(['mb-4'])}`}>{details.description}</p>
                    <h2 className={`${dt(['font-open-sans-bold'])} ${textSize}`}>
                        {details.servicesHeading}
                    </h2>
                    {!isEmpty(details.services) && (
                        <ul className={`${dt(['list-disc', 'ml-6', 'pl-2', 'mt-0'])} ${textSize}`}>
                            {details.services.map((service) => (
                                <li>{service}</li>
                            ))}
                        </ul>
                    )}
                    <div className={dt(['mt-6'])}>
                        {currentStore ? (
                            <p className={textSize}>
                                {messagesTexts.currentStore}
                                &nbsp;
                                <span className={dt(['font-open-sans-bold'])}>{currentStore}</span>
                                <Button
                                    automationId="at-appointment-store-change"
                                    size="Sm"
                                    className={`${textSize} ${dt(['ml-2'])}`}
                                    buttonType="Link"
                                    onClick={this.triggerStoreSelectionSlider}
                                >
                                    {messagesTexts.changeStoreLink}
                                </Button>
                            </p>
                        ) : (
                            <Button
                                automationId="at-appointment-store-select"
                                buttonType="Primary"
                                size="Md"
                                className={dt(['w-full', 'lg:w-[300px]'])}
                                onClick={this.triggerStoreSelectionSlider}
                            >
                                {messagesTexts.selectStoreLink}
                            </Button>
                        )}
                    </div>
                    {details.showAppointmentLink && (
                        <div className={`link-wrapper ${dt(['mt-6'])}`}>
                            <Button
                                automationId="at-ccpa-continue"
                                buttonType="Primary"
                                size="Md"
                                className={dt(['w-full', 'lg:w-[300px]'])}
                                onClick={getAppointmentLink}
                                isDisabled={!currentStore}
                            >
                                {openInNewTab && (
                                    <Icon
                                        iconType="svg"
                                        width="20px"
                                        height="20px"
                                        viewBox="0 0 40 40"
                                        className={`icon-external ${dt([
                                            'relative',
                                            'bottom-0.5',
                                            'right-1',
                                        ])}`}
                                    >
                                        <ExternalLink />
                                    </Icon>
                                )}
                                {messagesTexts.linkText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        locationServiceStoreInfo: state.locationServiceReducer,
        findStoresDetails: state.findStoresDetails,
        preferences: state.context?.preferences,
    };
}

const mapDispatchToProps = (dispatch) => ({
    sliderActions: bindActionCreators(sliderActions, dispatch),
    analyticsActions: bindActionCreators(analyticsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentCard);
